import React from "react";
import Footer from "../components/footer/en/Footer";
import Header from "../components/header/en/Header";
import Contents from "../components/pages/editProfile/en/Contents";

const EditProfile = () => {
    return (
        <>
            <Header />
            <Contents />
            <Footer />
        </>
    );
}

export default EditProfile;